/* global axios */

import ApiClient from './ApiClient';

class AiAudits extends ApiClient {
  constructor() {
    super('ai_audits', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new AiAudits();
